import { render, staticRenderFns } from "./main_resident.vue?vue&type=template&id=2955c320&scoped=true"
import script from "./main_resident.vue?vue&type=script&lang=js"
export * from "./main_resident.vue?vue&type=script&lang=js"
import style0 from "./main_resident.vue?vue&type=style&index=0&id=2955c320&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2955c320",
  null
  
)

export default component.exports